/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Documento richiesto dall\'azione operatore sulla domanda esercente
 */
export enum DocumentoConvenzioneRichiesto {

    NESSUNO = 'NESSUNO',

    CONVENZIONE_DA_FIRMARE = 'CONVENZIONE_DA_FIRMARE',

    CONTROFIRMA_FACOLTATIVA = 'CONTROFIRMA_FACOLTATIVA'
}

